import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ToolService {

  // 固定参数
  private uri = 'plan/api/business/tool';

  constructor(private httpClient: HttpClient) { }

  async addTool(tool: any) {
    return await this.httpClient.post(this.uri + '/add', tool).toPromise();
  }

  batchAddTools(tools: any) {
    return this.httpClient.post(this.uri + '/batchAdd', tools);
  }

  updateTool(tool: any) {
    return this.httpClient.put(this.uri + '/updateTool', tool).pipe(
      map((res: any) => res.code)
    );
  }

  getToolTypeList() {
    return this.httpClient.get(this.uri + '/queryAllType');
  }

  getToolStatusList() {
    return this.httpClient.get(this.uri + '/queryAllStatus');
  }

  getAllToolNames() {
    return this.httpClient.get(this.uri + '/queryAllToolNames');
  }

  async getAllToolsListByCondition(parm: any, pageNum: number, pageSize: number) {
    let url = this.uri + '/queryAllToolByCondition' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (parm.toolId == null || parm.toolId === undefined || parm.toolId === '') {
    } else {
      url = url + '&toolID=' + parm.toolId;
    }
    if (parm.toolName == null || parm.toolName === undefined || parm.toolName === '') {
    } else {
      url = url + '&toolName=' + parm.toolName;
    }
    if (parm.toolType == null || parm.toolType === undefined || parm.toolType === '') {
    } else {
      url = url + '&toolType=' + parm.toolType;
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }
  /**
   * 手机端分页查询工具列表信息
   */
  async getToolsListByCondition(parm: any, pageNum: number, pageSize: number) {
    let url = this.uri + '/queryToolByCondition' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (parm.toolName == null || parm.toolName === undefined || parm.toolName === '') {
    } else {
      url = url + '&toolName=' + parm.toolName;
    }
    if (parm.toolType == null || parm.toolType === undefined || parm.toolType === '') {
    } else {
      url = url + '&toolType=' + parm.toolType;
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }

  async getAllTools(pageNum: number, pageSize: number) {
    const url = this.uri + '/queryAllTool' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }

  async getToolsByStatusAndType(type: any) {
    const url = this.uri + '/selectToolByStatusAndType?toolType=' + type;
    const ret: any = await this.httpClient.get(url).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return null;
    }
    return ret.data;
  }

  async deleteTool(tNo: number) {
    const url = this.uri + '/deleteTool';
    const ret: any = await this.httpClient.delete(url, { params: { tNo: [tNo + ''] } }).toPromise();
    if (ret.code !== 200) {
      console.log(ret.msg);
      return 0;
    }
    return 1;
  }

  deleteToolBatch(data: any) {
    return this.httpClient.post(this.uri + '/deleteBatch', data);
  }

  async getToolTraces(toolId: number): Promise<any[]> {
    const result: any = await this.httpClient.get(this.uri + '/queryToolTrace/' + toolId).toPromise();
    if (result == null || result.code !== 200 || result.data == null || result.data.length <= 0) {
      return null;
    }
    return result.data;
  }
}
